"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FALLBACK_SIZE = 5;
var getEffectiveWidth = function (width, height, imageDetails) {
    var aspectRatio = imageDetails
        ? imageDetails.original_width / imageDetails.original_height
        : null;
    if (typeof width === 'number') {
        return width;
    }
    if (typeof height === 'number' && aspectRatio) {
        return height * aspectRatio;
    }
    return (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.original_width) || FALLBACK_SIZE;
};
var getEffectiveHeight = function (width, height, imageDetails) {
    var aspectRatio = imageDetails
        ? imageDetails.original_width / imageDetails.original_height
        : null;
    if (typeof height === 'number') {
        return height;
    }
    if (typeof width === 'number' && aspectRatio) {
        return width / aspectRatio;
    }
    return (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.original_height) || FALLBACK_SIZE;
};
var getEffectiveImageSize = function (width, height, imageDetails) { return ({
    width: getEffectiveWidth(width, height, imageDetails),
    height: getEffectiveHeight(width, height, imageDetails),
}); };
exports.default = getEffectiveImageSize;
//# sourceMappingURL=getEffectiveImageSize.js.map